import { Box } from '@wix/design-system';
import { ProductsGrid } from '@wix/package-picker-components';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { AdvancedPlansProductData } from 'types';
import { Experiments } from '../../../enums';
import { useSunriseProductCards } from '../hooks/useSunriseProductCards';
import s from './GridHeader.scss';
import { HeaderCycleSelectorDropdown } from './HeaderCycleSelectorDropdown';

interface GridHeaderProps {
  products: AdvancedPlansProductData[];
  innerRef?: React.RefObject<HTMLDivElement>;
  rootStore: RootStore;
  onClickSelect: (
    productData: AdvancedPlansProductData,
    clickSource?: string,
  ) => void;
}

const GridHeaderComp: React.FC<GridHeaderProps> = ({
  products,
  rootStore,
  onClickSelect,
  innerRef,
}) => {
  const productsCards = useSunriseProductCards({
    baseProducts: products,
    appStore: rootStore.appStore,
    clickSource: 'table',
    onSelectProduct: onClickSelect,
    minimizedDisplay: true,
  });
  const { pricesIncludeTax, isInSale, isAnonymous } = rootStore.appStore;
  const isCycleSelectorsInProductsPageEnabled =
    rootStore.appStore.experiments[Experiments.CycleSelectorsInProductsPage] ===
    'true';
  const cornerCellComponent = isCycleSelectorsInProductsPageEnabled
    ? HeaderCycleSelectorDropdown
    : undefined;

  return (
    <ProductsGrid.Header innerRef={innerRef} cornerCell={cornerCellComponent}>
      {productsCards.map((p, idx) => {
        const { title, cta, hat, price } = p.components;
        const zIndex = productsCards.length - idx;

        return (
          <ProductsGrid.Header.Cell
            key={idx}
            zIndex={zIndex}
            className={classNames(s.headerCell, {
              [s.sale]: isInSale,
              [s.tax]: pricesIncludeTax,
              [s.anonymous]: isAnonymous,
              [s.savings]: p.data.isShowingSavings,
            })}
          >
            <Box margin='6px' height='24px'>
              {hat}
            </Box>
            <Box align='center'>{title}</Box>
            <Box
              verticalAlign='middle'
              className='grid-price'
              paddingBottom='SP2'
            >
              {price}
            </Box>
            <Box className={s.cta} width='80%'>
              {cta}
            </Box>
          </ProductsGrid.Header.Cell>
        );
      })}
    </ProductsGrid.Header>
  );
};

export const GridHeader = withInjectedRootStore(GridHeaderComp);
